module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/main-view@2x_ef5b1044219851b00f3b7b0faa263dcd.png";